import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import { getReviewProofsOptions, useDeleteReviewProof, useUploadOrUpdateReviewProof } from './model/ReviewProofModel';

interface ReviewProofActionProps {
  reviewId: number;
  authors: Author[];
  variant?: 'compact';
}

export function ReviewProofAction({ reviewId, authors }: ReviewProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getReviewProofsOptions(reviewId));
  const uploadOrUpdateMutation = useUploadOrUpdateReviewProof(reviewId);
  const deleteMutation = useDeleteReviewProof(reviewId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="review"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
